import { CreateProductModel, ProductModel, UpdateProductModel } from "../../Models/ProductModel";
import api from "../axios";

export const productModelService = {
  get: async (id: string): Promise<ProductModel> => {
    const response = await api.get(`/product-model/${id}`);
    return response.data;
  },

  getAll: async (): Promise<ProductModel[]> => {
    const response = await api.get('/product-model');
    return response.data;
  },

  create: async (data: CreateProductModel): Promise<string> => {
    const response = await api.post('/product-model', data);
    return response.data;
  },

  update: async (data: UpdateProductModel): Promise<boolean> => {
    const response = await api.put('/product-model', data);
    return response.data;
  },

  delete: async (id: string): Promise<boolean> => {
    const response = await api.delete(`/product-model/${id}`);
    return response.data;
  }
};
